/* eslint-disable jsx-a11y/control-has-associated-label */
import useAxiosRequest from '@/hooks/useAxiosRequest'
import clinicalCarePriorities from '@/services/api/clinicalCarePriorities'
import PropTypes from 'prop-types'
import React from 'react'
import LoadManager from '../LoadManager'

function ClinicalCarePriorityPicker({
  active, selected, onSelect, onClose,
}) {
  const { data, error, loading } = useAxiosRequest(clinicalCarePriorities.all)

  return (
    <div className={`modal ${active ? 'active' : ''}`}>
      <a type="button" className="modal-overlay" aria-label="Close" onClick={onClose} />
      <div className="modal-container">
        <div className="modal-header">
          <a
            type="button"
            className="btn btn-clear float-right"
            onClick={onClose}
          />
          <div className="modal-title h5">
            Selecione a prioridade
          </div>
        </div>
        <div className="modal-body">
          <LoadManager loading={loading} error={error}>
            {Boolean(data) && (
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Prioridade</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {
                    data.map((priority) => (
                      <tr key={priority.id} className="c-hand" onClick={() => onSelect(priority)}>
                        <td>
                          <div className="d-flex align-center">
                            <span
                              style={{
                                backgroundColor: priority.color,
                                borderRadius: 5,
                                width: 30,
                                height: 30,
                                display: 'inline-block',
                                marginRight: 10,
                              }}
                            />
                            <div style={{ lineHeight: 1.2 }}>
                              {priority.title}
                              <div className="text-small">{priority.description}</div>
                            </div>
                          </div>
                        </td>
                        <td className="text-right">
                          {selected?.id === priority.id && (
                            <i className="fas fa-check" />
                          )}
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            )}
          </LoadManager>
        </div>
      </div>
    </div>
  )
}

ClinicalCarePriorityPicker.propTypes = {
  active: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  selected: PropTypes.objectOf(Object),
}

ClinicalCarePriorityPicker.defaultProps = {
  selected: null,
}

export default ClinicalCarePriorityPicker
